import { derived } from 'svelte/store';
import { settingsStore } from '../stores/settingsStore.js';
import { normalizeLocale, publicPath } from './locales.js';
import { resolvePublicRoute } from '../content/publicRoutes.js';
import { getCopy, appMessages } from '../content/publicSite.js';
import { webMessages } from './webMessages.js';

export { languages, publicPath } from './locales.js';
export const locale = derived(settingsStore, settings => normalizeLocale(settings.language));
export const t = derived(locale, language => (key, values = {}) => {
  const messages = appMessages(language), nav = getCopy(language).nav;
  const template = nav[key] ?? webMessages[language][key] ?? messages[key] ?? appMessages('en')[key] ?? key;
  return String(template).replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
});

export function setLocale(value) {
  const language = normalizeLocale(value);
  settingsStore.update(settings => ({ ...settings, language }));
  const url = new URL(window.location.href);
  const route = resolvePublicRoute(url.pathname);
  if (route?.locale) {
    url.pathname = publicPath(language, route.page);
    url.searchParams.delete('lang');
  } else url.searchParams.set('lang', language);
  window.history.replaceState({}, '', url);
}
